<template>
  <keep-alive>
    <component
      v-bind:is="previewItemFromType(listPreviews, codename)"
      v-bind:audiourl="audio"
      v-bind:listaudio="audios"
      v-bind:thumburl="thumb"
      v-bind:listimages="thumbs">
    </component>
  </keep-alive>
</template>

<script>

import TypesMixin from 'mixins/types'
import SingleFreeVoice from 'components/previews/SingleFreeVoice'
import SingleFunnyVoice from 'components/previews/SingleFunnyVoice'
import ImagesResources from 'components/previews/ImagesResources'
import AudioResources from 'components/previews/AudioResources'
import MixOffer from 'components/previews/MixOffer'

export default {
  name: 'multi-preview-item',
  props: ['listPreviews', 'codename', 'icon'],
  mixins: [TypesMixin],
  methods: {
    previewItemFromType (item, codename) {
      this.audio = null
      this.audios = null
      this.thumb = null
      this.thumbs = null
      switch (this.guess_offer_type(codename, item)) {
        case 'freeVoice':
          this.audio = item[0].url
          return 'single-free-voice'
        case 'funnyVoice':
          this.audio = item[0].url
          this.thumb = item[0].thumbnail_url
          return 'single-funny-voice'
        case 'speedcamera':
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'images-resources'
        case 'traffic':
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'images-resources'
        case 'locatorPack':
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'images-resources'
        case 'locator':
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'images-resources'
        case 'voicesPack':
          this.audios = this.getValues(item, 'url')
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'audio-resources'
        case 'mix':
          this.audios = this.getValues(item, 'url')
          this.thumbs = this.getValues(item, 'thumbnail_url')
          return 'mix-offer'
        default:
          return 'default'
      }
    }
  },
  components: {
    SingleFreeVoice,
    SingleFunnyVoice,
    ImagesResources,
    AudioResources,
    MixOffer
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MultiPreviewItem.vue